<template>
  <v-row class="pa-0 ma-0 mb-md-5">
    <v-col
      v-for="(button, i) in data"
      :key="i"
      class="col-12 col-md-4 px-md-4 px-lg-9"
    >
      <v-row>
        <v-btn
          class="col-md-12 btn"
          :class="{ active: selected === i }"
          color="#cacaca"
          rounded
          dark
          depressed
          large
          @click="
            selected = i;
            $analytics(eventCategory, 'click', button.eventLabel);
          "
        >
          {{ button.title }}
        </v-btn>
      </v-row>
    </v-col>
    <v-col
      v-for="(item, key) in data"
      :key="`desc${key}`"
      cols="12"
      class="pa-0 ma-0 py-4"
      :class="{ 'd-none': key !== selected }"
    >
      <v-row>
        <v-col
          :class="{ 'pa-0 ma-0': !isMobile }"
          cols="12"
          md="6"
          order="2"
          order-md="1"
        >
          <p class="text-body pa-0" v-html="item.text" />
        </v-col>
        <v-col
          align="center"
          class="pa-0 py-7 py-md-0"
          cols="12"
          md="5"
          offset-md="1"
          order="1"
          order-md="2"
        >
          <div v-if="item.description" class="featured mx-md-10 pa-4">
            <span v-if="item.descriptionFocus" class="focus">
              {{ item.descriptionFocus }}<br />
            </span>
            <span v-html="item.description" />
          </div>
          <v-img
            contain
            max-width="400"
            class="rounded-image"
            :src="item.image"
            :alt="item.imageAlt"
          />
        </v-col>
      </v-row>
    </v-col>

    <!-- <v-col class="text-body pa-0" cols="12" md="6" order="2" order-md="1">
        <p v-html="data[selected].text" />
      </v-col> -->
    <!-- <v-col
        align="center"
        class="pa-0 py-7 py-md-0"
        cols="12"
        md="5"
        offset-md="1"
        order="1"
        order-md="2"
      >
        <div v-if="data[selected].description" class="featured mx-md-10 pa-4">
          <span v-if="data[selected].descriptionFocus" class="focus">
            {{ data[selected].descriptionFocus }}<br />
          </span>
          <span v-html="data[selected].description" />
        </div>
        <v-img
          v-for="(button, i) in data"
          v-show="selected === i"
          :key="`image_${i}`"
          contain
          max-width="400"
          class="rounded-image"
          :src="button.image"
          :alt="button.imageAlt"
        />
      </v-col> -->
  </v-row>
</template>

<script>
export default {
  name: 'CompleteSolution',
  props: {
    data: {
      type: Array,
      required: true,
    },
    eventCategory: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    selected: 0,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.btn
  font-size: 1em !important
  color: #000
  background-color: lightgrey !important
  font-weight: normal
  font-family: 'Proxima Nova', sans-serif !important

.btn.active
  background-color: #01ee55 !important
  color: #fff !important

.featured
  border-radius: 20px
  border: 1px solid rgb(202, 202, 202)
  font-size: 1.2em
  align-items: center
  justify-content: center
  text-align: center
  @media screen and (max-width: $sm)
    font-size: 1.3em
  @media screen and (max-width: $xs)
    font-size: 1.1em
  .focus
    color: $primary
    font-size: 1.5em

.more
  width: 30%
  @media screen and (max-width: $sm)
    width: 30%
  @media screen and (max-width: $xs)
    width: 70%

.new-color
  .btn
    font-family: 'metropolisregular', sans-serif !important
    color: #003036
  .btn.active
    background-color: #26d07c !important
</style>
